import { createContext, useContext, useState, ReactNode, FC } from 'react';

interface PaginationModel {
  page: number;
  pageSize: number;
}

type ClickedLinkContextType = {
  clickedLinkId: string | null;
  setClickedLinkId: (id: string | null) => void;
  paginationModel: PaginationModel;
  setPaginationModel: (model: PaginationModel) => void;
};

const ClickedLinkContext = createContext<ClickedLinkContextType | undefined>(undefined);

export const useClickedLink = () => {
  const context = useContext(ClickedLinkContext);
  if (!context) {
    throw new Error('useClickedLink must be used within a ClickedLinkProvider');
  }
  return context;
};

type ClickedLinkProviderProps = {
  children: ReactNode;
};

export const ClickedLinkProvider: FC<ClickedLinkProviderProps> = ({ children }) => {
  const [clickedLinkId, setClickedLinkId] = useState<string | null>(null);
  const [paginationModel, setPaginationModel] = useState<PaginationModel>({ page: 0, pageSize: 25 });

  return (
    <ClickedLinkContext.Provider value={{ clickedLinkId, setClickedLinkId, paginationModel, setPaginationModel }}>
      {children}
    </ClickedLinkContext.Provider>
  );
};
